export const initialization = 'INITIALIZATION';
export const resetNotifs = 'RESET_NEW_NOTIFICATIONS_NUMBER';
export const updatePaniers = 'UPDATE_PANIERS';
export const updateVendeurPaniers = 'UPDATE_VENDEUR_PANIERS';
export const sideDrawerStatus = 'SIDE_DRAWER_STATUS';
export const updateBalance = 'UPDATE_BALANCE';
export const newTontine = 'NEW_TONTINE';
export const newTontineAchat = 'NEW_TONTINE_ACHAT';
export const updatePseudo = 'UPDATE_PSEUDO';
export const logOut = 'LOG_OUT';